import { coreAddTagsSyncSlice } from './add';
import { CoreTagsName } from './name';
import { postTag } from '../../api';
import { updateTagReferences } from './_idMap/actions';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTagsPostAsyncSlice = createPostAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.TAG_CREATED, (action) => ({ name: action.data.name })),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				coreAddTagsSyncSlice.syncActionCreator({
					autoTagged: false,
					description: request.description,
					hexColor: request.hexColor,
					id: response.sonarObjectTagId,
					name: request.name,
					ownerIds: request.ownerIds
				}),
			(request, response) =>
				updateTagReferences([
					{
						autoTagged: false,
						description: request.description,
						hexColor: request.hexColor,
						id: response.sonarObjectTagId,
						name: request.name,
						ownerIds: request.ownerIds
					}
				])
		]
	},
	name: CoreTagsName,
	receive: true,
	request: true,
	requestHandler: postTag
});
